import { apiClient, Auth } from '@/shared/api'

export type SurveyRequirementsParams = {
  action: 'DELETE' | 'HIDE'
}

export const getSurveyRequirements = async ({
  action,
}: SurveyRequirementsParams) => {
  const response = await apiClient.get<{ surveyRequired: boolean }>({
    endpoint: `/host/rooms/survey-requirements`,
    queryParams: { action },
    auth: Auth.REQUIRED,
  })

  return response
}
